import { memo } from 'react'
import { Footer } from './Footer'

export const Contact = memo(function Contact() {
  return (
<section id="contact" className="section-immersive contact-immersive">
  <div className="section-content-immersive">
    <div className="content-center">
      <span className="section-label-immersive">Get In Touch</span>
      <h2 className="section-title-immersive">
        Let's Build
        <span className="gradient"> Something Amazing</span>
      </h2>
      <p className="text-large center">
        I'm always interested in hearing about new projects, innovative ideas,
        <br />
        or opportunities to collaborate on something extraordinary.
      </p>

      <div className="contact-methods-immersive">
        <a href="mailto:liamkande@icloud.com" className="contact-card-immersive">
          <div className="contact-icon-immersive">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M4 8l12 10 12-10M4 24V8l12 10 12-10v16H4z" strokeLinecap="round" />
            </svg>
          </div>
          <div className="contact-label-immersive">Email</div>
          <div className="contact-value-immersive">liamkande@icloud.com</div>
        </a>

        <a
          href="https://linkedin.com/in/liamkande"
          className="contact-card-immersive"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="contact-icon-immersive">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
              <path d="M8 12h4v12H8V12zM10 6a2 2 0 110 4 2 2 0 010-4zM16 12h4v2h.1c.6-1 2-2 4-2 4.3 0 5 2.8 5 6.4V24h-4v-5c0-1.5 0-3.4-2.1-3.4-2.1 0-2.4 1.6-2.4 3.3V24h-4V12z" />
            </svg>
          </div>
          <div className="contact-label-immersive">LinkedIn</div>
          <div className="contact-value-immersive">Connect with me</div>
        </a>

        <a
          href="https://github.com/liamkande"
          className="contact-card-immersive"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="contact-icon-immersive">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
              <path d="M16 2a14 14 0 00-4.43 27.28c.7.13.96-.3.96-.67v-2.38c-3.89.84-4.71-1.88-4.71-1.88a3.71 3.71 0 00-1.56-2.05c-1.27-.87.1-.85.1-.85a2.94 2.94 0 012.14 1.45 3 3 0 004.08 1.16 2.93 2.93 0 01.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4 5.4 0 011.44-3.76 5 5 0 01.14-3.7s1.17-.38 3.85 1.43a13.3 13.3 0 017 0c2.67-1.81 3.84-1.43 3.84-1.43a5 5 0 01.14 3.7 5.4 5.4 0 011.44 3.76c0 5.38-3.27 6.56-6.39 6.91a3.33 3.33 0 01.95 2.59v3.84c0 .46.25.81.96.67A14 14 0 0016 2z" />
            </svg>
          </div>
          <div className="contact-label-immersive">GitHub</div>
          <div className="contact-value-immersive">View my code</div>
        </a>
      </div>

      <div className="contact-cta-immersive">
        <a href="mailto:liamkande@icloud.com" className="btn-immersive primary large">
          Send Me a Message
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M4 10h12M10 4l6 6-6 6" strokeLinecap="round" />
          </svg>
        </a>
      </div>

      <Footer />
    </div>
  </div>
</section>
  )
})
